import { Article } from '../Models';

const headers = new Headers();
headers.append('Accept-Language', document.querySelector('html')!.lang);
headers.append('Content-Type', 'application/json');

export const YesService = {
    async getRecentArticles(
        ids: number[] | null,
        area: string | null
    ): Promise<Article[]> {
        const response = await fetch('/Umbraco/api/YesApi/GetRecentArticles', {
            method: 'POST',
            body: JSON.stringify({
                ids,
                area,
            }),
            headers,
        });
        return await response.json();
    },
};
